const tempItemReducer = (
    state = { 
        tempItems: JSON.parse(localStorage.getItem('tempItems') || '{}') 
    }, 
    action
    ) => {
    switch(action.type) {
        case "CREATE_TEMP_ITEM": {
            const newState = {
                ...state,
                tempItems: { ...state.tempItems, [action.item._id]: action.item }
            };
            localStorage.setItem('tempItems', JSON.stringify(newState.tempItems));
            return newState;
        }
        case "UPDATE_TEMP_ITEM": {
            const newState = {
                ...state,
                tempItems: { ...state.tempItems, [action.tempId]: { ...state.tempItems[action.tempId], ...action.updates } }
            };
            localStorage.setItem('tempItems', JSON.stringify(newState.tempItems));
            return newState;
        }
        case "UPDATE_TEMP_ITEM_ID": {
            const { oldTempId, newTempItem } = action;
            const { [oldTempId]: removed, ...remainingItems } = state.tempItems;
            const newState = {
                ...state,
                tempItems: {
                    ...remainingItems,
                    [newTempItem._id]: newTempItem
                }
            };
            localStorage.setItem('tempItems', JSON.stringify(newState.tempItems));
            return newState;
        }
        case "REMOVE_TEMP_ITEM": {
            const { [action.tempId]: _, ...rest } = state.tempItems;
            localStorage.setItem('tempItems', JSON.stringify(rest));
            return { ...state, tempItems: rest };
        }
        case "CLEAR_TEMP_ITEMS":
            localStorage.removeItem('tempItems');
            return { tempItems: {} };

        default:
            return state;
    }
}

export default tempItemReducer